module.exports = __webpack_public_path__ + "img/y_2023_hover.06a81e36.png";